const SimpleService = ({url='', serviceParams, signal}) =>{
    return fetch(url, {signal, ...serviceParams});
}

export default SimpleService;